module.exports = "/_next/static/chromiums/apple-touch-startup-1242x2688-image-2606ae68333e444dee51b93a3d3d72ab.png";